module.exports = __webpack_public_path__ + "static/media/Dr. Sonali Gupta.e84867de.png";